import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { fetchAudits, fetchAuditsCSV } from '../actions/audits'

import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'
import PinRecoverList from '../components/PinRecoverList'

import PinRecoverFilterForm from '../forms/PinRecoverFilterForm'

import '../styles/PinRecoverView.css'

class PinRecoverView extends React.Component {
  constructor(props) {
    super(props)

    this.handleCSV = this.handleCSV.bind(this)
  }

  componentDidMount() {
    const year = new Date().getFullYear()
    const startDate = `${year}-01-01`
    const endDate = `${year}-12-31`
    const { role, customerId } = this.props
    const customer = role === 'ADMIN' ? '' : customerId
    this.props.fetchAudits(customer, '', 'PIN_RECOVER', startDate, endDate)
  }

  handleCSV() {
    const { fetchAuditsCSV, form } = this.props
    const formValues = form.PinRecoverFilterForm && form.PinRecoverFilterForm.values
    fetchAuditsCSV(
      formValues ? formValues.Machine : '',
      'PIN_RECOVER',
      formValues ? formValues.StartDate : '',
      formValues ? formValues.EndDate : ''
    )
  }

  renderResume() {
    const { audits, error, loading } = this.props

    if (error) return <ErrorMessage message={error.message} />
    if (!audits || loading) return <LoadingProgress />

    // Count by Evento type
    const byType = {}
    audits.forEach(a => {
      const key = a.Evento || 'OTROS'
      byType[key] = (byType[key] || 0) + 1
    })

    return (
      <div className="pinrecover-summary-grid">
        <div className="pinrecover-summary-stat">
          <div className="pinrecover-stat-icon" style={{ color: '#022040' }}>
            <i className="fas fa-key"></i>
          </div>
          <div>
            <div className="pinrecover-stat-value">{audits.length}</div>
            <div className="pinrecover-stat-label">Total recuperaciones</div>
          </div>
        </div>
        {Object.entries(byType).sort((a, b) => b[1] - a[1]).map(([tipo, count]) => (
          <div key={tipo} className="pinrecover-summary-stat">
            <div className="pinrecover-stat-icon" style={{ color: '#0a4080' }}>
              <i className="fas fa-tag"></i>
            </div>
            <div>
              <div className="pinrecover-stat-value">{count}</div>
              <div className="pinrecover-stat-label">{tipo}</div>
            </div>
          </div>
        ))}
      </div>
    )
  }

  renderAudits() {
    const { audits, error, loading } = this.props

    if (error) return <ErrorMessage message={error.message} />
    if (!audits || loading) return <LoadingProgress />
    if (audits.length === 0) {
      return <div className="pinrecover-no-data"><i className="fas fa-inbox mr-2"></i>No hay registros para el período seleccionado.</div>
    }

    return <PinRecoverList audits={audits} />
  }

  render() {
    return (
      <div className="pinrecover-view">
        <div className="pinrecover-header">
          <div className="pinrecover-header-content">
            <div className="pinrecover-header-text">
              <h1>
                <i className="fas fa-key mr-3"></i>
                <span className="text-vw-dark mr-1">Recuperación</span>
                <span className="text-vw-light">de Pines</span>
              </h1>
            </div>
            <div className="pinrecover-header-actions">
              <button className="pinrecover-header-btn success" onClick={this.handleCSV}>
                <i className="fas fa-file-excel"></i>
                <span>Descargar CSV</span>
              </button>
            </div>
          </div>
        </div>

        <div className="pinrecover-filter-card">
          <div className="pinrecover-filter-header">
            <h3><i className="fas fa-filter"></i> Filtros</h3>
          </div>
          <div className="pinrecover-filter-body">
            <PinRecoverFilterForm />
          </div>
        </div>

        <div className="pinrecover-section-card">
          <div className="pinrecover-section-header">
            <i className="fas fa-chart-bar mr-2"></i>Resumen del período
          </div>
          <div className="pinrecover-section-body">
            {this.renderResume()}
          </div>
        </div>

        <div className="pinrecover-section-card">
          <div className="pinrecover-section-header">
            <i className="fas fa-list mr-2"></i>Registros
          </div>
          <div className="pinrecover-section-body p-0">
            {this.renderAudits()}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  audits: state.audits.audits,
  error: state.audits.error,
  loading: state.audits.loading,
  role: state.auth.role,
  customerId: state.auth.id,
  form: state.form
})

const mapDispatchToProps = dispatch => ({
  fetchAudits: bindActionCreators(fetchAudits, dispatch),
  fetchAuditsCSV: bindActionCreators(fetchAuditsCSV, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(PinRecoverView)


